// axios
import axios from 'axios'

export default axios.defaults.baseURL = "http://localhost:54335/api";

// export default axios.create({
//   domain
//   // You can add your headers here
// })
